import _ from 'lodash'
import { connect } from 'react-redux'

const CheckoutErrorsPanel = ({ errors, checkoutErrors }) => {
  // Filter out null/undefined values and technical errors from errors
  const errorsPresent = _(errors)
    .omitBy(_.isNull)
    .omitBy((value, key) => {
      // Filter out technical/internal errors that shouldn't be shown to users
      const technicalErrors = ['Utf8Encode', 'Utf8Decode', 'utf8Encode', 'utf8Decode']
      return technicalErrors.includes(key)
    })
    .value()

  if (Object.values(errorsPresent).length > 0) {
    return (
      <div className="alert alert-danger p-md" role="alert">
        <div style={{ fontWeight: 700, marginBottom: '10px' }}>
          We encountered one or more errors while processing your order for checkout. Please review them below and reach
          out to our support team if you need assistance.
        </div>
        {Object.entries(errorsPresent).map(([key, val], i) => {
          if (val) {
            // if error is present
            return (
              <div style={{ marginBottom: '15px' }} key={i}>
                {key.includes('_') ? (
                  <>{errors[key]?.message ?? errors[key] ?? val}</>
                ) : (
                  <>
                    <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong>{' '}
                    {errors[key]?.message ?? errors[key] ?? val}
                  </>
                )}
              </div>
            )
          }
        })}
      </div>
    )
  } else {
    return null
  }
}

const mapStateToProps = state => {
  return {
    errors: state.errors,
    checkoutErrors: state.checkout.errors
  }
}

export default connect(mapStateToProps)(CheckoutErrorsPanel)
